<template>
  <main class="child-safety">
    <article>
      <h1>MoTobi Child Safety Standards</h1>
      <p class="effective-date">Effective September 16, 2026</p>

      <section>
        <h2>Adults-only service</h2>
        <p>
          MoTobi is a dating and matching service for adults aged 18 and over.
          Minors are not permitted to create an account or use the service. We
          may restrict or remove an account when we reasonably believe that the
          account belongs to a minor.
        </p>
      </section>

      <section>
        <h2>Zero tolerance for child sexual abuse and exploitation</h2>
        <p>
          MoTobi prohibits child sexual abuse and exploitation (CSAE) in every
          form. Prohibited conduct includes creating, uploading, requesting,
          sharing, storing, or promoting child sexual abuse material (CSAM), as
          well as grooming, sexual solicitation of a minor, sextortion,
          trafficking, or any attempt to facilitate sexual contact with a minor.
          Sexualized images, text, links, or other content involving or
          appearing to involve a minor are also prohibited.
        </p>
      </section>

      <section>
        <h2>Reporting and blocking</h2>
        <p>
          Users can report another user or content through MoTobi's in-app
          reporting controls and can block another user to stop further contact.
          Urgent or additional child-safety concerns may be reported to
          <a href="mailto:motobi.helpdesk@gmail.com"
            >motobi.helpdesk@gmail.com</a
          >. If a child is in immediate danger, contact local law enforcement or
          emergency services first.
        </p>
      </section>

      <section>
        <h2>Our response</h2>
        <p>
          We review child-safety reports and may immediately remove content,
          restrict or permanently terminate accounts, prevent re-registration,
          and preserve relevant records where permitted by law. When we become
          aware of apparent CSAM or other conduct that must be reported, we
          report it to the appropriate authorities or designated reporting body,
          including the National Center for Missing &amp; Exploited Children
          (NCMEC) where applicable, and cooperate with lawful investigations.
        </p>
      </section>

      <section>
        <h2>Compliance and contact</h2>
        <p>
          MoTobi complies with applicable child-safety laws and maintains
          processes intended to prevent, identify, report, and address CSAE. Our
          designated child-safety point of contact is
          <a href="mailto:motobi.helpdesk@gmail.com"
            >motobi.helpdesk@gmail.com</a
          >.
        </p>
      </section>
    </article>
  </main>
</template>

<style scoped lang="scss">
.child-safety {
  min-height: 100vh;
  padding: 96px 24px 64px;
  background: #fff;
  color: #202124;

  article {
    max-width: 820px;
    margin: 0 auto;
  }

  h1 {
    margin: 0 0 8px;
    font-size: 36px;
    line-height: 1.25;
  }

  .effective-date {
    margin-bottom: 40px;
    color: #5f6368;
  }

  section {
    margin-top: 32px;
  }

  h2 {
    margin-bottom: 12px;
    font-size: 24px;
  }

  p {
    margin: 0;
    font-size: 16px;
    line-height: 1.75;
  }

  a {
    color: #b13d8d;
  }
}

@media (max-width: 600px) {
  .child-safety {
    padding: 72px 20px 48px;

    h1 {
      font-size: 30px;
    }

    h2 {
      font-size: 21px;
    }
  }
}
</style>
